/* eslint-disable angular/factory-name */
angular.
module("digiexam.services").
factory("group", function group(
	$http,
	DxGroupConstructor
) {
	"use strict";
	return {
		create: function create(title) {
			return $http.post("/group/create/", {title: title}).
			then(function handleResponse(response) {
				return response.data;
			});
		},
		get: function get(id) {
			return $http.get("/group/" + id).then(function handleResponse(response) {
				// Populate student emails
				response.data.group.students.forEach(function forEachStudent(student) {
					student.email = response.data.emails[student.id];
				});

				return new DxGroupConstructor(response.data.group);
			});
		},
		getAll: function getAll() {
			return $http.get("/group/list/").then(function handleResponse(response) {
				return response.data;
			});
		},
		deregisterStudent: function deregisterStudent(groupId, studentId) {
			return $http.post("/group/deregister/", {
				groupId: groupId,
				studentId: studentId,
			}).then(function handleResponse(response) {
				return response.data;
			});
		},
		setArchived: function setArchived(groupId, isArchived) {
			return $http.post("/group/setarchived/", {
				groupId: groupId,
				isArchived: isArchived,
			}).then(function handleResponse(response) {
				return response.data;
			});
		},
		setTitle: function setTitle(groupId, title) {
			return $http.post("/group/settitle/", {
				groupId: groupId,
				title: title,
			}).then(function handleResponse(response) {
				return response.data;
			});
		},
		query: function query(queryParams) {
			var requestConfig = {
				url: "/group/query",
				method: "GET",
				params: queryParams,
			};

			return $http(requestConfig).then(function handleResponse(response) {
				return response.data;
			});
		},
	};
});
